var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8625 5.54031C27.0963 6.29031 27.0963 7.53031 24.8625 8.28031L17.1102 10.9003C16.2299 11.2003 14.7845 11.2003 13.9042 10.9003L6.15185 8.28031C3.91813 7.53031 3.91813 6.29031 6.15185 5.54031L13.9042 2.92031C14.7845 2.62031 16.2299 2.62031 17.1102 2.92031L19.633 3.77031",
    stroke: "#6F767E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.94531 11C3.94531 11.84 4.7731 12.81 5.78485 13.15L14.7066 16.17C15.3898 16.4 16.1651 16.4 16.8352 16.17L25.7569 13.15C26.7687 12.81 27.5965 11.84 27.5965 11",
    stroke: "#6F767E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.94531 16C3.94531 16.93 4.66799 17.77 5.78485 18.15L14.7066 21.17C15.3898 21.4 16.1651 21.4 16.8352 21.17L25.7569 18.15C26.8738 17.77 27.5965 16.93 27.5965 16",
    stroke: "#6F767E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer);
export default __webpack_public_path__ + "static/media/layer.7e5e49e41dbec8f3f82e587887bad752.svg";
export { ForwardRef as ReactComponent };